export default "/images/logo.png?7ad8080df4f2dfe35ac9b4820d72b3a2";